import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { primary, navy, borderSoft, muted } from '../Layout/Resources/Theme'

const toneStyles = {
  primary: {
    bg: 'rgba(255, 21, 42, 0.08)',
    color: primary,
    border: 'rgba(255, 21, 42, 0.2)',
    hover: 'rgba(255, 21, 42, 0.14)'
  },
  danger: {
    bg: 'rgba(255, 21, 42, 0.06)',
    color: '#C41022',
    border: 'rgba(255, 21, 42, 0.18)',
    hover: 'rgba(255, 21, 42, 0.12)'
  },
  secondary: {
    bg: '#F9FAFB',
    color: navy,
    border: borderSoft,
    hover: '#F3F4F6'
  },
  ghost: {
    bg: '#fff',
    color: muted,
    border: borderSoft,
    hover: '#F3F4F6'
  }
}

const Btn = styled.button`
  min-height: 34px;
  min-width: ${props => props.$withLabel ? 'auto' : '34px'};
  padding: ${props => props.$withLabel ? '0 12px' : '0'};
  border-radius: 10px;
  border: 1px solid ${props => (toneStyles[props.tone] || toneStyles.secondary).border};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  cursor: pointer;
  background: ${props => (toneStyles[props.tone] || toneStyles.secondary).bg};
  color: ${props => (toneStyles[props.tone] || toneStyles.secondary).color};
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;
  line-height: 1;
  font-size: 0.75rem;
  font-weight: 700;
  white-space: nowrap;

  &:hover {
    background: ${props => (toneStyles[props.tone] || toneStyles.secondary).hover};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  i {
    font-size: 0.78rem;
  }
`

const ActionIconButton = ({ tone, icon, label, children, className, type, ...rest }) => (
  <Btn
    type={type || 'button'}
    tone={tone}
    className={className}
    $withLabel={Boolean(label)}
    title={rest.title || label}
    {...rest}
  >
    {icon ? <i className={icon} /> : null}
    {label ? <span>{label}</span> : children}
  </Btn>
)

ActionIconButton.propTypes = {
  tone: PropTypes.oneOf(['primary', 'danger', 'secondary', 'ghost']),
  icon: PropTypes.string,
  label: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  type: PropTypes.string
}

ActionIconButton.defaultProps = {
  tone: 'ghost',
  icon: '',
  label: '',
  className: '',
  type: 'button'
}

export default ActionIconButton
